import React from "react";
import {
  Box,
  Typography,
  TextField
} from "@mui/material";

const TensionArterial = ({
  tensionPMM, setTensionPMM,
  tensionPAS, setTensionPAS,
  tensionPAD, setTensionPAD
}) => {
  const [errorPmm, setErrorPmm] = React.useState("");
  const [errorPas, setErrorPas] = React.useState("");
  const [errorPad, setErrorPad] = React.useState("");

  return (
    <Box sx={{ marginBottom: 2, border: "1px solid #ccc", padding: 2, borderRadius: 1 }}>
      <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
        Tensión Arterial
      </Typography>
      <Box sx={{ display: "flex", gap: 2 }}>
        <TextField
          label="Tensión PAS"
          variant="outlined"
          type="number"
          inputProps={{ step: "1" }}
          value={tensionPAS}
          onChange={(e) => {
            const newValue = e.target.value;
            if (newValue !== "" && !/^\d+$/.test(newValue)) {
              setErrorPas("No se permite numero decimales");
            } else {
              setErrorPas("");
            }
            setTensionPAS(newValue);
          }}
          error={Boolean(errorPas)}
          helperText={errorPas}
        />
        <TextField
          label="Tensión PAD"
          variant="outlined"
          type="number"
          inputProps={{ step: "1" }}
          value={tensionPAD}
          onChange={(e) => {
            const newValue = e.target.value;
            if (newValue !== "" && !/^\d+$/.test(newValue)) {
              setErrorPad("No se permite numero decimales");
            } else {
              setErrorPad("");
            }
            setTensionPAD(newValue);
          }}
          error={Boolean(errorPad)}
          helperText={errorPad}
        />
        <TextField
          label="Frecuencia Cardíaca (PMM)"
          variant="outlined"
          type="number"
          inputProps={{ step: "any" }}
          value={tensionPMM}
          onChange={(e) => {
            const newValue = e.target.value;
            if (newValue !== "" && !/^\d+(\.\d+)?$/.test(newValue)) {
              setErrorPmm("Introduce un número válido");
            } else {
              setErrorPmm("");
            }
            setTensionPMM(newValue);
          }}
          error={Boolean(errorPmm)}
          helperText={errorPmm}
        />
      </Box>
    </Box>
  );
};

export default TensionArterial;
